import { render } from "./cardFooter.vue?vue&type=template&id=0bb2bb88&scoped=true&lang=pug"
import script from "./cardFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./cardFooter.vue?vue&type=script&setup=true&lang=js"

import "./cardFooter.vue?vue&type=style&index=0&id=0bb2bb88&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb2bb88"]])

export default __exports__